import type { ReactNode } from 'react';
import { Modal } from 'antd';

export interface FloatingWindowProps {
  open: boolean;
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  width?: number | string;
}

/**
 * A wide window that does NOT dim the page: the table behind it stays visible for reference (a price, a
 * name) while the owner fills the form. It is not closed by a click outside. antd still locks the page
 * scroll while it is open, and the page under it should not react to clicks — the caller switches its
 * pointer events off for as long as the window is open.
 */
export function FloatingWindow({
  open,
  title,
  onClose,
  children,
  footer = null,
  width = 'min(1400px, 96vw)',
}: FloatingWindowProps) {
  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      footer={footer}
      width={width}
      mask={false}
      maskClosable={false}
      destroyOnHidden
      style={{ top: 40 }}
      styles={{ body: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' } }}
    >
      {children}
    </Modal>
  );
}
